module.exports = __webpack_public_path__ + "static/media/instagram.f8148b4d.svg";